export const IntersectionsList = () => {
  return (
    <div className="p-3 pb-1">
      Selecciona el polígono que tiene mayor importancia frente a los otros
      polígonos en la intersección.
    </div>
  );
};
